export default class StdteminateslestirmeRequestmodel {
  AracTarifeGrupKodu: string;
  StandartTeminatIdArray: number[];
}
